<template>
  <v-card flat>
    <v-card-title>
      My Subscriptions
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="items" :search="search">
      <template v-slot:item.trader="{ item }">
        <!-- <v-avatar size="30px" class="mr-2">
          <v-img v-if="item.trader.photoURL" :src="item.trader.photoURL" />
          <v-icon v-else>face</v-icon>
        </v-avatar>-->
        <span class="mr-2">{{ item.traderAccount.name }}</span>
      </template>
      <template v-slot:item.investor="{ item }">
        <!-- <v-avatar size="30px" class="mr-2">
          <v-img v-if="item.investor.photoURL" :src="item.investor.photoURL" />
          <v-icon v-else>face</v-icon>
        </v-avatar>-->
        <span class="mr-2">{{ item.investorAccount.name }}</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn color="primary" icon :loading="itemLoading === item" @click="onUnSubscribe(item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
        <!-- <v-btn color="primary" @click="onListTopics">test</v-btn> -->
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { SUBSCRIPTION } from "@/store/actions.type";
// import { mapGetters } from "vuex";

// import topic from "@/aws";

export default {
  name: "SubscriptionTable",
  components: {},
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Trader's Account",
          align: "start",
          sortable: true,
          value: "traderAccount.name"
        },
        { text: "Investor's Account", value: "investorAccount.name" },
        { text: "Actions", value: "action", sortable: false }
      ],
      itemLoading: null
    };
  },
  methods: {
    onUnSubscribe(subscriptionSchema) {
      this.itemLoading = subscriptionSchema;
      // call api.tradingif.com. Delete SNS and Firebase.
      this.$store.dispatch(SUBSCRIPTION.DEL, subscriptionSchema).then(val => {
        this.itemLoading = null;
        if (val.status == 200) {
          const index = this.items.indexOf(subscriptionSchema);
          this.items.splice(index, 1);
        }
      });
    }
  }
};
</script>

<style></style>
